import { filterObjectValues } from 'helpers/filter'

import { Mbusiness } from 'models/mbusiness'
import { IStatistic } from 'models/statistic'

import { downloadFileHandler } from 'shared/libs'

import api from '../api'
import { GetMbusinessListResponse, GetMbusinessParams } from './types'

export const mbusinessApi = api.injectEndpoints({
  endpoints: build => ({
    getMbusinessById: build.query<Mbusiness, Mbusiness['id']>({
      query: id => ({
        url: `/web/mbusiness/${id}/`,
      }),
    }),
    getMbusiness: build.query<GetMbusinessListResponse, GetMbusinessParams>({
      query: params => ({
        url: `/web/mbusiness/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    mbusinessStatistics: build.query<Array<IStatistic>, GetMbusinessParams>({
      query: params => ({
        url: `/web/mbusiness/statistics/`,
        params: filterObjectValues(params),
      }),
      keepUnusedDataFor: 60 * 5,
    }),
    downloadMbusinessExcel: build.mutation<void, GetMbusinessParams>({
      query: params => ({
        url: `/web/mbusiness/excel/`,
        params: filterObjectValues(params),
        responseHandler: downloadFileHandler,
        cache: 'no-cache',
      }),
    }),
  }),
})
